// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Loop = ({ size, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M36.6,31.2H7.7c-3.6,0-6.5-2.9-6.5-6.5v-1.3c0-3.6,2.9-6.5,6.5-6.5h1.9' />
      <path d='M11.5,16.8h28.8c3.6,0,6.5,2.9,6.5,6.5v1.3c0,3.6-2.9,6.5-6.5,6.5h-1.8' />
      <polyline points='29.3 23.9 36.5 31.2 29.3 38.4' />
      <polyline points='18.7 24.1 11.5 16.8 18.7 9.6' />
    </svg>
  );
};
